import EnhancedSignUpForm from 'components/auth/SignUpForm/styled';

export default EnhancedSignUpForm;
